module.exports = __webpack_public_path__ + "img/GEOIMG.685a66e3.jpg";